import type { FC } from 'react';
import styles from './Switch.module.scss';
import React from 'react';

interface SwitchProps {
    checked: boolean;
    onChange: (checked: boolean) => void;
    label: string;
    discription?: string;
    disabled?: boolean;
}

export const Switch: FC<SwitchProps> = ({ checked, onChange, label, discription, disabled }) => (
    <label className={styles.switch}>
        <input
            type="checkbox"
            checked={checked}
            disabled={disabled}
            onChange={(event) => onChange(event.target.checked)}
        />
        <span className={styles.track} />
        <div className={styles.text}>
            <span>
                {label}
            </span>
            <span className={styles.optionHint}>
                {discription}
            </span>
        </div>
    </label>
);
